import {useContext, useState} from 'react';
import {LoginContext, LoginScreen} from './LoginContext';
import {LogInLinkButton} from './SignInButton';
import {useTranslateFunction} from 'contexts/translation/TranslationContext';
import {getSignInErrorMessage} from './signInErrors';

export const EmailSentNotice = ({emailHandler, handlerArgs}) => {
  const [, setLoginState] = useContext(LoginContext);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const t = useTranslateFunction('miscUI');

  const handleResend = async () => {
    try {
      setError('');
      setLoading(true);
      await emailHandler(...handlerArgs);
      setLoading(false);
    } catch (error) {
      setError(
        getSignInErrorMessage(error, {
          fallback: 'Error sending email. Please try again.',
        }),
      );
      setLoading(false);
    }
  };
  return (
    <div className="d-flex flex-column align-items-center px-2">
      <h3>{t('Email sent!')}</h3>
      <p className="text-center">
        {t(
          "Please check your email for further instructions. If you don't see the email, check your spam folder.",
        )}
      </p>
      <div className="d-flex flex-row justify-content-center">
        <LogInLinkButton
          variant="link"
          onClick={() => setLoginState(LoginScreen.INIT_LANDING)}
        >
          {t('Go back')}
        </LogInLinkButton>
        <LogInLinkButton variant="link" onClick={handleResend}>
          {loading ? t('Loading') : t('Resend email')}
        </LogInLinkButton>
      </div>
      {error && (
        <p style={{color: 'red'}}>{t(error)}</p>
      )}
    </div>
  );
};
